import { useState } from "react";
import axios from 'axios';
import { API_URL } from "../../Env";
import { BaseAxios } from "../../lib/API/AxiosInstances";

const Register = ({ onRegister }) => {

    const [emailExists, setEmailExists] = useState(false);
    const [data, setData] = useState({
        email : null,
        password : null,
        repeatPassword : null
    });

    const [registerFailed, setRegisterFailed] = useState(false);
    
    const [passwordErrors, setPasswordErrors] = useState({
        minLength: false,
        noNumbers: false,
        noLetters: false,
        accepted: true
    });

    const verifyPassword = () => {
        let accepted = true;
        let minLength = data.password && data.password.length < 8;
        const noLetters = !(/.*([a-zA-Z]).*/.test(data.password));
        const noNumbers = !/.*\d.*/.test(data.password);
        const noMatch = data.password != data.repeatPassword;
        if(minLength || noLetters || noNumbers || noMatch)
            accepted = false;

        setPasswordErrors({ ...passwordErrors, accepted, minLength, noNumbers, noLetters, noMatch });

        return(accepted);
    }

    const onChange = ({ target }) => {
        setData({ ...data, [target.name] : target.value });
    }

    const onSubmit = (e) => {
        e.preventDefault();

        setEmailExists(false);

        if (!verifyPassword())
            return setRegisterFailed(true);

        BaseAxios.post(`user/register`, data)
            .then(() => {
                setRegisterFailed(false)
                onRegister({ email : data.email })
            })
            .catch((e) => {
                if(e.response)
                    setEmailExists(true);
                setRegisterFailed(true)
            });
    }

    return (
        <div className="d-flex flex-column">
            <form onSubmit={onSubmit}>
                <div style={{ flex : 1 }}>
                    <div class="register-header">Register</div> 
                    {registerFailed ? (
                        (passwordErrors.accepted ? (
                            (emailExists ? 
                                <div className="alert alert-danger text-center">
                                    Email already used, try to register with another email
                                </div>
                                :
                                <div className="alert alert-danger text-center">
                                    An error occured, please try again later.
                                </div>
                            )
                        ) : (
                            <div className="alert alert-danger text-center">
                                <p>
                                    Please fix these issues :
                                    <ul>
                                        {passwordErrors.minLength && <li>Password must have at least 8 charcters</li>}
                                        {passwordErrors.noNumbers && <li>Password must contain numbers</li>}
                                        {passwordErrors.noLetters && <li>Password must contain letters</li>}
                                        {passwordErrors.noMatch && <li>Password and Password confirmation are not identical</li>}
                                    </ul>
                                </p>
                            </div>
                        ))
                    ) : (
                        <p className="mt-3 text-center">Create a new account</p>
                    )}
                    <div className="form-group">
                        <label for="email">Email</label>
                        <input type="text" onChange={onChange} name="email" className="form-control" id="email" placeholder="Enter your email" />
                    </div>

                    <div className="form-group">
                        <label for="pwd">Password</label>
                        <input type="password" onChange={onChange} name="password" className="form-control" id="pwd" placeholder="Enter your password" />
                    </div>
                    <div className="form-group">
                        <label for="pwd">Confirm Password</label>
                        <input type="password" onChange={onChange} name="repeatPassword" className="form-control" id="pwd" placeholder="Re-enter your password" />
                    </div>
                </div>
                <div className="btns">
                    <button type="submit" className="btn-yellow w-100 " onClick={onSubmit}>Register</button>
                </div>
            </form>
        </div>
    )

}

export default Register;